import { CalendarConfigModel } from './calendar-config.model';
import { Expose, Type } from 'class-transformer';
import { ProjectConfigModel } from './project-config.model';
import { GlobalAppConfigModel } from './global-app-config.model';
import { TodoPlannerConfigModel } from './todo-planner-config.model';

export class SharedConfigWrapper {
  id: number = 0; // Add id to satisfy ngrx/entity.

  @Type(() => GlobalAppConfigModel)
  @Expose({ name: 'globalAppOptions' })
  public globalAppConfigModel: GlobalAppConfigModel = null;

  @Type(() => CalendarConfigModel)
  @Expose({ name: 'calendarOptions' })
  public calendarConfigModel: CalendarConfigModel = null;

  @Type(() => ProjectConfigModel)
  @Expose({ name: 'projectOptions' })
  public projectConfigModel: ProjectConfigModel = null;

  @Type(() => TodoPlannerConfigModel)
  @Expose({ name: 'todoPlannerOptions' })
  public todoPlannerConfigModel: TodoPlannerConfigModel = null;
}
